import type { FC } from "react";
import React from "react";

const SAMPLE_SQUARE_KCAL = 150;

export const CrumbChip: FC = () => (
  <div className="flex items-center gap-1.5 rounded-full bg-muted px-2 py-[3px]">
    <span
      className="inline-block size-3 rounded-[3px]"
      style={{ border: "1.5px dashed hsl(220deg 60% 45% / 0.6)" }}
    />
    <span className="font-mono text-[10.5px] text-muted-foreground">
      0/{SAMPLE_SQUARE_KCAL}
    </span>
  </div>
);
